import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface ListBlockProps {
  list: {
    label: string
    value: string
    isLineThrough?: boolean
  }[]
}

export const ListBlock = ({ list }: ListBlockProps) => {
  return (
    <Paper padding={[0, 16]}>
      {list.map((item) => (
        <div
          key={item.label}
          className={s.item}
        >
          <span className={clsx('semi-bold-14', s.label)}>{item.label}</span>
          <span
            className={clsx(
              'medium-13',
              s.value,
              item.isLineThrough && s.lineThrough,
            )}
          >
            {item.value}
          </span>
        </div>
      ))}
    </Paper>
  )
}
